/**
 * Visitor Management slice of the content renderer interaction.
 * Single contract for invite name, bulk-import state, and host info used by
 * ContentRenderer, PropertyInputBlock, AddInviteNameBlock, and validations.
 */
export type VisitorManagementFeatures = {
  hostInformation?: { hostTenantId?: string; hostEmail?: string };
  uploadedViaBulkImport?: boolean;
  inviteName?: string;
  hasSubmitterEmailConflict?: boolean;
  hasHostEmailConflict?: boolean;
};

export type InteractionWithVisitorManagement = {
  features?: {
    VisitorManagement?: VisitorManagementFeatures;
  };
};

/**
 * Safely reads the VisitorManagement slice from an interaction object.
 * Use instead of casting interaction so callers rely on a single contract.
 */
export function getVisitorManagementFeatures(
  interaction: unknown
): VisitorManagementFeatures | undefined {
  const i = interaction as InteractionWithVisitorManagement | null | undefined;
  return i?.features?.VisitorManagement;
}
